import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15a063a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container overflow-auto h-100 pt-4" }
const _hoisted_2 = { class: "col-12 text-center mb-3" }
const _hoisted_3 = { class: "text-center py-3" }
const _hoisted_4 = { class: "col-12 text-center mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Código de reserva", -1))
const _hoisted_6 = {
  class: "text-center py-3",
  style: {"line-break":"anywhere"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, " Enviamos por mail la confirmación de tu reserva y el código para participar de la actividad. "),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Deberás mostrar el mail el día de tu turno."),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-center",
    "py-3": ""
  }, "¡Te esperamos!")
], -1))
const _hoisted_8 = { class: "col-12 col-lg-6 text-center my-3" }
const _hoisted_9 = { class: "col-12 col-lg-6 text-center my-4 mb-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_AppResumeComponent = _resolveComponent("AppResumeComponent")!
  const _component_AppButtonResetNav = _resolveComponent("AppButtonResetNav")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppInfoTitles),
    _createVNode(_component_AppResumeComponent, {
      logo: "/img/icons/checked.svg",
      title: "resumen.agradecimiento",
      subtitle: "resumen.travesia"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.state.navigation.datosPersonales.personal.nombreApellido) + " tu reserva quedó confirmada! ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.state.navigation.codigoReserva), 1)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AppButtonResetNav)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        tag: "button",
        to: {
          name: 'voucher_cancelar',
          params: { codigoReserva: _ctx.state.navigation.codigoReserva }
        },
        class: "btn btn-danger text-center d-inline"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Cancelar reserva ")
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}